import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import germanBaseTrans from './translation-gen/de/de-base.json';
import englishBaseTrans from './translation-gen/en/en-base.json';
import dutchBaseTrans from './translation-gen/nl/nl-base.json';
import v4Fallback from './v4Fallback';

const germanTrans = {
  ...germanBaseTrans,
};

const englishTrans = {
  ...englishBaseTrans,
};

export const loadI18n = () => {
  return i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .use(LanguageDetector)
    .use(v4Fallback)
    .init({
      compatibilityJSON: 'v4',
      resources: {
        de: {
          translation: germanTrans,
        },
        en: {
          translation: englishTrans,
        },
        nl: {
          translation: dutchBaseTrans,
        },
      },
      fallbackLng: ['de'],
      supportedLngs: ['de', 'en', 'nl'],
      interpolation: {
        escapeValue: false,
      },
      detection: {
        order: ['localStorage', 'navigator'],
      },
      postProcess: ['v4Fallback'],
    });
};
